import { render, staticRenderFns } from "./NoticeTemplateEmailDialog.vue?vue&type=template&id=71348e20&scoped=true&"
import script from "./NoticeTemplateEmailDialog.vue?vue&type=script&lang=js&"
export * from "./NoticeTemplateEmailDialog.vue?vue&type=script&lang=js&"
import style0 from "./NoticeTemplateEmailDialog.vue?vue&type=style&index=0&id=71348e20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71348e20",
  null
  
)

export default component.exports